export default "__VITE_ASSET__uoL8xcxE__"